(function () {
  "use strict";

  function init(root) {
    if (!root || root.dataset.bcHeaderInit) return;
    root.dataset.bcHeaderInit = "1";

    var overlay = root.querySelector(".bc-overlay");
    var mnav = root.querySelector(".bc-nav");
    var curOpen = null;

    function closeAllMega() {
      if (mnav) {
        mnav.querySelectorAll(".bc-ni").forEach(function (n) {
          n.classList.remove("bc-open");
        });
      }
      if (overlay) overlay.classList.remove("bc-on");
      curOpen = null;
    }

    if (mnav) {
      mnav.querySelectorAll('.bc-ni[data-bc-mega="1"]').forEach(function (ni) {
        var trigger = ni.querySelector(".bc-nt");
        if (!trigger) return;
        trigger.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (curOpen === ni) {
            closeAllMega();
            return;
          }
          closeAllMega();
          ni.classList.add("bc-open");
          if (overlay) overlay.classList.add("bc-on");
          curOpen = ni;
        });
      });
    }

    if (overlay) overlay.addEventListener("click", closeAllMega);

    var mdEl = root.querySelector(".bc-mob-drawer");
    var mb1 = root.querySelector(".bc-mbtn");

    function openDrawer() {
      if (mdEl) mdEl.classList.add("bc-on");
      if (mb1) mb1.classList.add("bc-open");
      document.documentElement.classList.add("bc-drawer-open");
    }

    function closeDrawer(ctx) {
      var r = ctx || root;
      var d = r.querySelector(".bc-mob-drawer");
      var b = r.querySelector(".bc-mbtn");
      if (d) d.classList.remove("bc-on");
      if (b) b.classList.remove("bc-open");
      document.documentElement.classList.remove("bc-drawer-open");
    }

    if (mb1 && mdEl) {
      mb1.addEventListener("click", function () {
        if (mdEl.classList.contains("bc-on")) closeDrawer(root);
        else openDrawer();
      });
    }

    var mx = root.querySelector(".bc-mob-xbtn");
    if (mx) mx.addEventListener("click", function () { closeDrawer(root); });

    root.querySelectorAll(".bc-mob-sec .bc-mob-trig").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var s = btn.closest(".bc-mob-sec");
        if (!s) return;
        var was = s.classList.contains("bc-on");
        root.querySelectorAll(".bc-mob-sec").forEach(function (x) {
          x.classList.remove("bc-on");
        });
        if (!was) s.classList.add("bc-on");
      });
    });

    root.querySelectorAll(".bc-mob-chip").forEach(function (chip) {
      chip.addEventListener("click", function (e) {
        if (chip.tagName === "A") return;
        e.preventDefault();
        var target = chip.getAttribute("data-bc-scroll");
        root.querySelectorAll(".bc-mob-chip").forEach(function (c) {
          c.classList.remove("bc-on");
        });
        chip.classList.add("bc-on");
        if (target) {
          var el = document.getElementById(target);
          document.querySelector('.bc-mob-sec.bc-on').classList.remove('bc-on')
          el.classList.add('bc-on')
          if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    });

    var mobMenuOpen = root.querySelector(".bc-mob-bnav-open-menu");
    if (mobMenuOpen) mobMenuOpen.addEventListener("click", openDrawer);


    root.querySelectorAll("[data-open-search-modal]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var details = root.querySelector("details-modal.header__search details.search_details");
        if (details) {
          details.setAttribute("open", "");
          // console.log(124)
          var input = details.querySelector('input[type="search"]');
          // if (input) setTimeout(function () { input.click(); }, 200);
        }
      });
    });

    /* KY_22.05 start */
    var bcSearchDetails = root.querySelector("details-modal.header__search details.search_details");
    var bcSearchModal = root.querySelector("details-modal.header__search");

    function closeBcSearch() {
      if (!bcSearchDetails) return;

      if (bcSearchModal && typeof bcSearchModal.close === "function") {
        bcSearchModal.close(false);
      }

      bcSearchDetails.removeAttribute("open");

      root.classList.remove("bc-search-open");
      document.body.classList.remove("open_search_menu");
      document.body.classList.remove("sticky-search-menu-open");

      root.querySelectorAll("[data-bc-search-close]").forEach(function (btn) {
        btn.setAttribute("hidden", "");
      });

      if (root._bcStickyOnScroll) {
        requestAnimationFrame(root._bcStickyOnScroll);
      }
    }

    function syncBcSearchState() {
      if (!bcSearchDetails) return;
      var open = bcSearchDetails.hasAttribute("open");
      root.classList.toggle("bc-search-open", open);
      document.body.classList.toggle("open_search_menu", open);
      document.body.classList.toggle("sticky-search-menu-open", open);
      root.querySelectorAll("[data-bc-search-close]").forEach(function (btn) {
        if (open) {
          btn.removeAttribute("hidden");
        } else {
          btn.setAttribute("hidden", "");
        }
      });
      if (!open && root._bcStickyOnScroll) {
        requestAnimationFrame(root._bcStickyOnScroll);
      }
    }

    if (bcSearchDetails) {
      bcSearchDetails.addEventListener("toggle", syncBcSearchState);
      syncBcSearchState();
    }

    root.addEventListener("click", function (e) {
      if (!e.target.closest("[data-bc-search-close]")) return;
      e.preventDefault();
      e.stopPropagation();
      closeBcSearch();
    }, true);
    /* KY_22.05 end */

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        closeAllMega();
        closeDrawer(root);
        /* KY_22.05 */
        if (bcSearchDetails && bcSearchDetails.open) {
          closeBcSearch();
        }
      }
    });

    function padBody() {
      if (window.matchMedia("(max-width: 960px)").matches) {
        document.body.classList.add("bc-mob-nav-pad");
      } else {
        document.body.classList.remove("bc-mob-nav-pad");
        closeDrawer(root);
      }
    }

    padBody();
    window.addEventListener("resize", padBody);
  }

  document.querySelectorAll("#bc-header").forEach(init);

  document.addEventListener("shopify:section:load", function (e) {
    var el = e.target;
    var root = el.id === "bc-header" ? el : el.querySelector("#bc-header");
    if (root) {
      delete root.dataset.bcHeaderInit;
      init(root);
    }
  });
})();
